import React from "react";
import { useTranslation } from "react-i18next";
import { FullHeadscalePreAuthKey } from "src/api/generated/frontend_internal_v1";
import { ApiInternal } from "src/api/api_internal";
import { ConfirmDialog } from "src/components/base/confirm-dialog";
import { notify } from "src/components/base/toast";

/**
 * The properties for {@link ExpirePreAutKeyDialog}
 */
export type ExpirePreAuthKeyDialogProps = {
    /** Whether the dialog is open */
    isOpen: boolean;
    /** Callback for closing the popup */
    onClose: () => void;
    /** Callback for successful expire */
    onExpire: () => void;
    /** The key to expire */
    preAuthKey: FullHeadscalePreAuthKey | undefined;
};

/**
 * Dialog to expire a pre-auth key.
 */
export default function ExpirePreAutKeyDialog(props: ExpirePreAuthKeyDialogProps) {
    const [t] = useTranslation("dialog-expire-pre-auth-key");

    if (!props.preAuthKey) return null;

    return (
        <ConfirmDialog
            open={props.isOpen}
            onClose={props.onClose}
            onConfirm={async () => {
                if (!props.preAuthKey) return;
                await ApiInternal.preAuthKeys.expirePreAuthKey(props.preAuthKey.uuid);
                notify.success(t("toast.key-expired-successfully"));
                props.onClose();
            }}
            title={t("heading.expire-key")}
            description={t("description.expire-key")}
            confirmLabel={t("button.expire-key")}
        />
    );
}
